import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../hooks/useEditData";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormCheckbox from '../../Generic/FormCheckbox';
import { useSetMenu } from "../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import * as yup from "yup";
const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { mainStore } = useStore();
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  useSetMenu(mainStore.TypeOfToolMenuType, mainStore.TypeOfToolMenuNo);
    const schema = yup.object({
      name: yup
        .string()
        .required(t('requiredField'))
        .max(50, t('maxLength', { max: 50 })),
    });

  const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
  const onSubmit = data => updateData(data);

  const { notFound, updateData } = useEditData(axiosPrivate, "/TypeOfTools", id, setValue, navigate);

  const goToList = () => {
    navigate("/TypeOfTool/List");
  };

  if (notFound) {
    return <div className="not-found-myDiv">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1>{t("pageNotFoundTitle")}</h1>
          <p>{t("noDataWithIdMessage")}</p>
          <button onClick={goToList} className="btn btn-primary">
            {t("goTo") + " " + t("list") + " " + t("typeOfTools")}
          </button>
        </div>
      </div>
    </div>;
  }

  return (
    <FormLayout title={t("typeOfToolEditTitle")} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
      <FormInput label="typeOfTool" name="name"  register={register} errors={errors} />
      <FormCheckbox label="isActive" register={register} name="isActive" colSize={4} />
    </FormLayout>
  );
};

export default observer(Edit);